export function recipeCopyDraft(source, today = new Date().toISOString().slice(0, 10)) {
  return {
    produs_finit_id: source.produs_finit_id,
    cod_reteta: `${String(source.cod_reteta || '').slice(0, 44)}-COPIE`,
    denumire: `${source.denumire || ''} (copie)`.slice(0, 200),
    data_start: today,
    data_stop: null,
    activa: 0,
    observatii: source.observatii || '',
    linii: (source.linii || []).map(line => ({
      material_id: line.material_id,
      cantitate: line.cantitate,
      um_id: line.um_id,
      pierdere_proc: line.pierdere_proc ?? 0,
      material_cod_str: line.material_cod_str,
      material_denumire: line.material_denumire,
      um_denumire: line.um_denumire,
    })),
  };
}

export function formatRecipeQuantity(value) {
  const raw = String(value ?? '0');
  if (!/^[+-]?\d+(\.\d+)?$/.test(raw)) return raw;
  const [whole, decimals = ''] = raw.split('.');
  return `${whole}.${decimals.replace(/0+$/, '').padEnd(4, '0')}`;
}
